import React from "react";
import { useDialog } from "../../../context";
import { CheckValue } from "../../../Service/service";
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import StyledButton from "../StyledButton";
import StyledDialog from "./StyledDialog";

const ErrorDialog = () => {
  const { error, hideError } = useDialog();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));
  const handleClose = () => {
    if (CheckValue(error.close)) {
      error.close();
    }
    hideError();
  };
  return (
    <React.Fragment>
      <StyledDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        fullScreen={fullScreen}
        open={CheckValue(error)}
      >
        <DialogTitle x={{ m: 0, p: 2 }} id="customized-dialog-title">
          Error
        </DialogTitle>
        <DialogContent sx={{ width: 400 }} dividers>
          <Typography sx={{ textAlign: "center" }} gutterBottom>
            {error?.message}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <StyledButton variant="contained" color="error" onClick={handleClose}>
            Ok
          </StyledButton>
        </DialogActions>
      </StyledDialog>
    </React.Fragment>
  );
};

export default ErrorDialog;
